import { FormInput } from '../../..';
import { FormInputModel } from '../../../../models';
import { HandleValueModel } from '../../../../models/component/HandleValueModel';
import { Row } from 'reactstrap';
import SettingsFormProps from '../SettingsFormProps';
import { TemperatureModeComfort } from '../icons';
import { observer } from 'mobx-react';

const TemperatureComfortField = ({ translate, settingsModel, accessTable, disabled }: SettingsFormProps) => {
  const label = translate(x => x.forms.airdome.settings.temperatureComfort);

  return <Row>
    <div className="settings-field-icon">
      <TemperatureModeComfort style={{ width: '100%', height: 40 }} />
    </div>
    <div className="settings-field-input">
      <FormInput {...{
        model: new FormInputModel({
          label,
          validationSchema: settingsModel.temperatureComfortValidationSchema.label(label),
          placeholder: label,
          handleValueModel: new HandleValueModel({
            setValue: settingsModel.temperatureComfort.setValue,
            inputType: 'number'
          }),
          inputId: 'TemperatureComfort',
          value: settingsModel.temperatureComfort.Value ? (Math.round(settingsModel.temperatureComfort.Value * 10) / 10).toString() : '',
          readonly: disabled || !accessTable.edit
        })
      }} />
    </div>
  </Row>;
};

export default observer(TemperatureComfortField);
